import React from 'react';
import {Box, Typography} from '@mui/material';

/** Large monospace value with a caption label — used in coverage modal footers. */
export default function CoverageMetric({label, value, suffix = ''}) {
    return (
        <Box>
            <Typography variant="h6" fontFamily="Roboto Mono, monospace">
                {value == null ? '—' : `${value}${suffix}`}
            </Typography>
            <Typography variant="caption" color="text.secondary">{label}</Typography>
        </Box>
    );
}
